import { render } from "./AppNotifications.vue?vue&type=template&id=d53c7604&scoped=true"
const script = {}

import "./AppNotifications.vue?vue&type=style&index=0&id=d53c7604&lang=scss&scoped=true"

import exportComponent from "/home/forge/s.thebuyhive.com/expertsourcing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d53c7604"]])

export default __exports__